import { Box, Typography, Button, useTheme, Container, Table, TableHead, TableRow, TableCell, TableContainer, TableBody, IconButton, LinearProgress, Avatar, Select, MenuItem } from "@mui/material"
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useNavigate } from 'react-router'
import { useScheduled } from "../../../shared/context/scheduledContext"
import { useUtiles } from "../../../shared/context/utilesContext"
import moment from "moment-timezone"
import { useAbility } from "../../../shared/context/AbilityContext"
import { useState, useMemo, useEffect } from "react"
export default function PlanTaskView() {
    const theme = useTheme()

    const navigate = useNavigate()

    const ability = useAbility();

    const { getAllGroupScheduled, groupScheduledAll, resetGroupScheduled, deleteGroupScheduled, loadingGroupScheduledAll } = useScheduled()
    const { locationString, getFirstNameAndLastName } = useUtiles()

    useEffect(() => {
        getAllGroupScheduled()
    }, [])

    const handleNewGroupScheduled = () => {
        resetGroupScheduled()
        navigate('/task/scheduled/plan')
    }


    useEffect(() => {
        if (!ability.can('read', 'SCHEDULED.PLANNING')) {
            navigate('/')
        }
    }, [ability])



    const [yearApplySelected, setYearApplySelected] = useState(new Date().getFullYear())

    useEffect(() => {
        //Inicializar el yearApplySelected con el año actual
        setYearApplySelected(new Date().getFullYear())
    }, [])


    //Actualizar el yearApplySelected cuando cambie el año
    useEffect(() => {
        getAllGroupScheduled({ year_apply: yearApplySelected })
    }, [yearApplySelected])



    return (
        <Container maxWidth="xl"> 
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px'
            }}>
                <Typography sx={{ fontWeight: 'normal', fontSize: '1.2rem' }}>Tareas programadas {yearApplySelected}</Typography>




                <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <Select
                        value={yearApplySelected}
                        onChange={(e) => setYearApplySelected(e.target.value)}
                        size="small"
                    >
                        <MenuItem value={2024}>2024</MenuItem>
                        <MenuItem value={2025}>2025</MenuItem>
                        <MenuItem value={2026}>2026</MenuItem>
                        <MenuItem value={2027}>2027</MenuItem>
                        <MenuItem value={2028}>2028</MenuItem>
                        <MenuItem value={2029}>2029</MenuItem>
                        <MenuItem value={2030}>2030</MenuItem>
                    </Select>
                    {ability.can('create', 'SCHEDULED.PLANNING') &&
                        <Button variant="contained" color="primary" startIcon={<CalendarMonthOutlinedIcon />} onClick={handleNewGroupScheduled}>Nueva programación</Button>
                    }
                </Box>


            </Box>


            <Box sx={{ p: { xs: 0.5, md: 1 }, borderRadius: '10px', backgroundColor: theme.palette.background.paper, boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)' }}>
                {loadingGroupScheduledAll && <LinearProgress />}
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Descripción</TableCell>
                                <TableCell>Activo</TableCell>
                                <TableCell>Fecha de creación</TableCell>
                                <TableCell>Cant. tareas</TableCell>
                                <TableCell>Creado por</TableCell>
                                <TableCell></TableCell>
                            </TableRow>

                        </TableHead>
                        <TableBody>
                            {groupScheduledAll.map((groupScheduled) => (
                                <TableRow key={groupScheduled.id} sx={{ cursor: 'pointer' }} onClick={() => navigate(`/task/scheduled/plan/${groupScheduled.hash_code}`)}>
                                    <TableCell>{groupScheduled.name}</TableCell>
                                    <TableCell>{locationString(groupScheduled.asset)}</TableCell>
                                    <TableCell>{moment(groupScheduled.created_at).format('DD/MM/YYYY')}</TableCell>
                                    <TableCell>{groupScheduled.cant_tasks}</TableCell>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            {groupScheduled.created_by.avatar && (
                                                <Avatar src={groupScheduled.created_by.avatar} alt={groupScheduled.created_by.name} sx={{ width: 28, height: 28, fontSize: 14 }} />
                                            )}
                                            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{getFirstNameAndLastName((groupScheduled?.created_by?.name))}</span>
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', gap: '5px' }}>
                                            {!groupScheduled.exists_tasks_assigned_to_ot && <IconButton onClick={(e) => { deleteGroupScheduled(groupScheduled.id); e.stopPropagation() }}><DeleteIcon /></IconButton>}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

        </Container>
    )
}